import AmetrasPictureUploadFieldTemplate from '@/fields/picture/AmetrasPictureUploadFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasCheckBoxWithThreeStatesTemplate from '@/fields/checkbox/AmetrasCheckBoxWithThreeStatesTemplate.vue';
import AmetrasSwitchTemplate from '@/fields/switch/AmetrasSwitchTemplate.vue';
import AmetrasSignatureFieldTemplate from '@/fields/signature/AmetrasSignatureFieldTemplate.vue';
import AmetrasBase64FieldWrapper from '@/fields/wrapper/AmetrasBase64FieldWrapper.vue';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasTextAreaMonoSpaceGridFieldTemplate from '@/fields/text-area/AmetrasTextAreaMonoSpaceGridFieldTemplate.vue';
import AmetrasTextModuleFieldTemplate from '@/fields/text-area/AmetrasTextModuleFieldTemplate.vue';
import AmetrasDateFieldTemplate from '@/fields/date/AmetrasDateFieldTemplate.vue';
import AmetrasMonthFieldTemplate from '@/fields/date/AmetrasMonthFieldTemplate.vue';
import AmetrasTimeFieldTemplate from '@/fields/time/AmetrasTimeFieldTemplate.vue';
import AmetrasDurationFieldTemplate from '@/fields/duration/AmetrasDurationFieldTemplate.vue';
import AmetrasTimeWithSecondsFieldTemplate from '@/fields/time/AmetrasTimeWithSecondsFieldTemplate.vue';
import AmetrasDateTimeFieldTemplate from '@/fields/datetime/AmetrasDateTimeFieldTemplate.vue';
import AmetrasCOSLTemplate from '@/fields/cosl/AmetrasCOSLTemplate.vue';
import AmetrasAttachmentTemplate from '@/fields/attachment/AmetrasAttachmentTemplate.vue';
import AmetrasMechanicSearchTemplate from '@/fields/mechanic/AmetrasMechanicSearchTemplate.vue';
import AmetrasPdfFieldTemplate from '@/fields/pdf/AmetrasPdfFieldTemplate.vue';
import AmetrasMapsFieldTemplate from '@/fields/maps/AmetrasMapsFieldTemplate.vue';
import AmetrasUploadFieldTemplate from '@/fields/upload/AmetrasUploadFieldTemplate.vue';
import AmetrasSingleFileUploadFieldTemplate from '@/fields/upload/AmetrasSingleFileUploadFieldTemplate.vue';
import AmetrasImportTemplate from '@/fields/upload/AmetrasImportTemplate.vue';
import AmetrasHolidayFieldTemplate from '@/fields/holiday/AmetrasHolidayFieldTemplate.vue';
import AmetrasDateWeekNumberFieldTemplate from '@/fields/weeknumber/AmetrasDateWeekNumberFieldTemplate.vue';
import DynamicDocumentTemplate from '@/views/dynamicdocuments/dynamic-document-template.vue';
import DynamicDocumentPreviewTemplate from '@/views/dynamicdocuments/dynamic-document-preview-template.vue';
import DynamicDocumentExportTemplate from '@/views/dynamicdocuments/dynamic-document-export-template.vue';
import DynamicDocumentImportTemplate from '@/views/dynamicdocuments/dynamic-document-import-template.vue';
import AmetrasInfoBoxFieldTemplate from '@/fields/text/AmetrasInfoBoxTemplate.vue';
import Vue, {AsyncComponent, ComponentOptions} from 'vue';
import AmetrasListTableFieldTemplate from '@/fields/list-table/AmetrasListTableFieldTemplate.vue';
import AmetrasHexColorPickerTemplate from '@/fields/hex-color-picker/AmetrasHexColorPickerTemplate.vue';
import AmetrasMachineWorkingAreaBoundaryTemplate from '@/fields/machine-working-area-boundary/AmetrasMachineWorkingAreaBoundaryTemplate.vue';
import AmetrasAdvancedTimelineButtonTemplate from '@/fields/button/AmetrasAdvancedTimelineButtonTemplate.vue';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import AmetrasArticleInfoReplacementTemplate from '@/fields/article-info-replacement/AmetrasArticleInfoReplacementTemplate.vue';
import AmetrasEmailFieldTemplate from '@/fields/text/AmetrasEmailFieldTemplate.vue';
import GoogleMapsTemplate from '@/fields/gmaps/GoogleMapsTemplate.vue';
import AmetrasAlertTemplate from '@/fields/alert/AmetrasAlertTemplate.vue';
import AmetrasEmailListFieldTemplate from '@/fields/text/AmetrasEmailListFieldTemplate.vue';
import AmetrasBreakTimeListTemplate from '@/fields/break-time-list/AmetrasBreakTimeListTemplate.vue';
import AmetrasPhoneFieldTemplate from '@/fields/text/AmetrasPhoneFieldTemplate.vue';

export type DynamicFieldResolverComponent = ComponentOptions<Vue> | typeof Vue | AsyncComponent;

type DataTypeBasedMapping = Partial<Record<DisguiseDto.EnumDataType, DynamicFieldResolverComponent>> | DynamicFieldResolverComponent;
type UIBasedMapping = Partial<Record<DisguiseDto.EnumUiType, DataTypeBasedMapping>>;

class DynamicFieldResolver {

    private static componentRegister: UIBasedMapping = {
        INPUT: {
            TEXT: AmetrasTextFieldTemplate,
            NUMBER: AmetrasNumberFieldTemplate,
            NUMBER_ALLOW_ZERO: AmetrasNumberFieldTemplate,
        },
        LABEL: {
            TEXT: AmetrasTextFieldTemplate,
            NUMBER: AmetrasNumberFieldTemplate,
            NUMBER_ALLOW_ZERO: AmetrasNumberFieldTemplate,
        },
        INPUT_UPPERCASE: AmetrasTextFieldTemplate,
        INPUT_SECRET: AmetrasTextFieldTemplate,
        LIST: AmetrasTextFieldTemplate,
        EMAIL: AmetrasEmailFieldTemplate,
        EMAIL_LIST: AmetrasEmailListFieldTemplate,
        ARTICLENO: AmetrasTextFieldTemplate,
        ARTICLE_INFO_REPLACEMENT: AmetrasArticleInfoReplacementTemplate,
        PICTURE_UPLOAD: AmetrasPictureUploadFieldTemplate,
        SELECT: AmetrasSelectFieldTemplate,
        CHECKBOX: AmetrasCheckBoxTemplate,
        CHECKBOX_WITH_THREE_STATES: AmetrasCheckBoxWithThreeStatesTemplate,
        SWITCH: AmetrasSwitchTemplate,
        SIGNATURE: AmetrasSignatureFieldTemplate,
        TEXTAREA: {
            BASE64: AmetrasBase64FieldWrapper,
            TEXT: AmetrasTextAreaFieldTemplate
        },
        TEXTMODULE: AmetrasTextModuleFieldTemplate,
        DATE: AmetrasDateFieldTemplate,
        YEAR_MONTH: AmetrasMonthFieldTemplate,
        TIME: AmetrasTimeFieldTemplate,
        DURATION: AmetrasDurationFieldTemplate,
        TIME_WITH_SECONDS: AmetrasTimeWithSecondsFieldTemplate,
        DATETIME: AmetrasDateTimeFieldTemplate,
        TABLE: () => import('@/views/datatable/DataTableTemplate.vue'),
        FORM: () => import('@/views/formular/FormTemplate.vue'),
        COMPANY_SELECTION_V2: AmetrasCOSLTemplate,
        ATTACHMENT: AmetrasAttachmentTemplate,
        MECHANIC_SEARCH: AmetrasMechanicSearchTemplate,
        PDF: AmetrasPdfFieldTemplate,
        GMAPS: AmetrasMapsFieldTemplate,
        FILE_UPLOADS: AmetrasUploadFieldTemplate,
        SINGLE_FILE_UPLOAD: AmetrasSingleFileUploadFieldTemplate,
        IMPORT_EXCEL: AmetrasImportTemplate,
        INFOMESSAGE: AmetrasInfoBoxFieldTemplate,
        DYNAMIC_DOCUMENT_MGMT: DynamicDocumentTemplate, // achtung! typeSpecificSettings settings
        DYNAMIC_DOCUMENT_PREVIEW: DynamicDocumentPreviewTemplate, // achtung! typeSpecificSettings settings
        HOLIDAY: AmetrasHolidayFieldTemplate,
        EXPORT_DYNAMIC_DOCUMENT: DynamicDocumentExportTemplate,
        IMPORT_DYNAMIC_DOCUMENT: DynamicDocumentImportTemplate,
        WEEK_NUMBER: AmetrasDateWeekNumberFieldTemplate,
        LIST_TABLE: AmetrasListTableFieldTemplate,
        HEX_COLOR_PICKER: AmetrasHexColorPickerTemplate,
        MACHINE_WORKING_AREA_BOUNDARY: AmetrasMachineWorkingAreaBoundaryTemplate,
        TEXTAREA_MONOSPACE_GRID: AmetrasTextAreaMonoSpaceGridFieldTemplate,
        GMAPS_V2: GoogleMapsTemplate,
        ALERT: AmetrasAlertTemplate,
        BREAK_TIMES_LIST: AmetrasBreakTimeListTemplate,
        PHONE: AmetrasPhoneFieldTemplate,
    };

    private static componentRegisterForDTFilter: UIBasedMapping = {
        ...DynamicFieldResolver.componentRegister,
        TEXTMODULE: () => import('@/fields/text/AmetrasTextFieldTemplate.vue'),
        CHECKBOX: AmetrasCheckBoxWithThreeStatesTemplate
    };

    private static componentRegisterForTimelineFilter: UIBasedMapping = {
        ...DynamicFieldResolver.componentRegister,
        BUTTON: AmetrasAdvancedTimelineButtonTemplate,
    };

    resolveComponent(uiType: DisguiseDto.EnumUiType | undefined, dataType: DisguiseDto.EnumDataType | undefined) {
        return this.resolveComponentFromMap(uiType, dataType, DynamicFieldResolver.componentRegister);
    }

    resolveComponentForDTFilter(uiType: DisguiseDto.EnumUiType | undefined, dataType: DisguiseDto.EnumDataType | undefined) {
        return this.resolveComponentFromMap(uiType, dataType, DynamicFieldResolver.componentRegisterForDTFilter);
    }

    resolveComponentForTimelineFilter(uiType: DisguiseDto.EnumUiType | undefined, dataType: DisguiseDto.EnumDataType | undefined) {
        return this.resolveComponentFromMap(uiType, dataType, DynamicFieldResolver.componentRegisterForTimelineFilter);
    }

    private resolveComponentFromMap(
        uiType: DisguiseDto.EnumUiType | undefined,
        dataType: DisguiseDto.EnumDataType | undefined,
        mapping: UIBasedMapping
    ) {
        let uiBasedMapping;
        if (uiType === undefined) { // 1
            throw new Error('uiType undefined');
        } else {
            uiBasedMapping = mapping[uiType]; // 2
        }

        let result: DynamicFieldResolverComponent | undefined;

        switch (typeof uiBasedMapping) {
            case 'function': { // 3
                result = uiBasedMapping;
                break;
            }
            case 'object': { // 4
                const castedUiBasedMapping = uiBasedMapping as Partial<Record<DisguiseDto.EnumDataType, DynamicFieldResolverComponent>>;
                if (dataType === undefined) {
                    throw new Error('dataType undefined');
                } else {
                    result = castedUiBasedMapping[dataType]; // 5
                }
                break;
            }
        }

        if (result === undefined) { // 6
            throw new Error('Unknown type constellation. uiType: ' + uiType + ', dataType: ' + dataType);
        }

        return result;
    }

}

const DYNAMIC_FIELD_RESOLVER_INSTANCE = new DynamicFieldResolver();

export {
    DYNAMIC_FIELD_RESOLVER_INSTANCE
};
